import { SEARCH_FILTERS } from 'state/Search/constants';

export const getTypesHandler = component => {
  const { props } = component;
  return () => {
    const { customRadioEnabled, onDemandEnabled, translate } = props;
    return [
      {
        filter: 'station',
        key: SEARCH_FILTERS.LIVE,
        requiresCustomRadio: false,
        requiresOnDemand: false,
        title: translate('Live Stations'),
      },
      {
        filter: 'artist',
        key: SEARCH_FILTERS.ARTIST,
        requiresCustomRadio: false,
        requiresOnDemand: false,
        title: translate('Artists'),
      },
      {
        filter: 'bundle',
        key: SEARCH_FILTERS.BUNDLE,
        requiresCustomRadio: true,
        requiresOnDemand: true,
        title: translate('Albums'),
      },
      {
        filter: 'track',
        key: SEARCH_FILTERS.SONG,
        requiresCustomRadio: true,
        requiresOnDemand: false,
        title: translate('Songs'),
      },
      {
        filter: 'playlist',
        key: SEARCH_FILTERS.COLLECTION,
        requiresCustomRadio: false,
        requiresOnDemand: false,
        title: translate('Playlists'),
      },
      {
        filter: 'podcast',
        key: SEARCH_FILTERS.PODCAST,
        requiresCustomRadio: false,
        requiresOnDemand: false,
        title: translate('Podcasts'),
      },
    ]
      .filter(type => (type.requiresCustomRadio ? customRadioEnabled : true))
      .filter(type => (type.requiresOnDemand ? onDemandEnabled : true));
  };
};

export const getFilterTypeHandler = component => {
  return searchFilter =>
    getTypesHandler(component)().find(type => type.filter === searchFilter) ||
    '';
};
